import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { costs } from '../data/problems';
export function ProblemSection() {
  return <section className="border-t border-slate-700/60 bg-slate-950 py-16 sm:py-20" aria-labelledby="problem-title" data-id="element-160" data-mp="30hzhn1ayjuld">
      <div className="mx-auto max-w-4xl px-4" data-id="element-161" data-mp="2vp6euiz1uwbx">
        <div className="text-center" data-id="element-162" data-mp="39hcs9xatip7o">
          <SectionHeading id="problem-title" data-id="element-163" data-mp="39gb3yr4sk680">Does This Sound <span className="text-amber-400" data-id="element-164" data-mp="35gkhv0q7me9t">Familiar?</span></SectionHeading>
          <p className="mx-auto mt-6 max-w-3xl text-lg leading-relaxed text-slate-300" data-id="element-165" data-mp="35in6phfmm1cy">
            You work with machines that move with oil or compressed air — presses, injection moulding machines, mobile
            equipment, automated lines — but when a cylinder slows down, a pump starts whining or a valve won&apos;t shift,
            you&apos;re not sure where to start. Circuit diagrams look like a foreign language, and the
            &ldquo;solution&rdquo; ends up being changing parts until something works.
          </p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-10 rounded-2xl border border-slate-700 bg-slate-900 p-6 shadow-lg shadow-black/30 sm:p-8" data-id="element-166" data-mp="od9kail28ogd">
          <p className="mb-5 inline-flex items-center gap-2 text-xl font-extrabold uppercase text-white" data-id="element-167" data-mp="125z90urz47h6">
            <AlertTriangleIcon className="h-5 w-5 text-amber-400" aria-hidden="true" data-id="element-168" data-mp="1c1spuqcq6n4r" />
            The real cost:
          </p>
          <ul className="grid gap-4 sm:grid-cols-2" data-id="element-169" data-mp="1g3nti1i4pclp">
            {costs.map(item => <li key={item} className="flex gap-3 text-sm leading-relaxed text-slate-300" data-id="element-170" data-mp="3dt5m6r0mnmp7">
                <span className="mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full bg-blue-300" aria-hidden="true" data-id="element-171" data-mp="3hur3qpo3wp5q" />
                {item}
              </li>)}
          </ul>
        </motion.div>

        <div className="mt-10 text-center" data-id="element-172" data-mp="p2d5kb4l8bfv">
          <p className="mx-auto max-w-2xl text-lg font-bold text-white" data-id="element-173" data-mp="k1z6hikysbtz">
            You don&apos;t need more scattered information.
          </p>
          <p className="mt-3 text-2xl font-extrabold uppercase tracking-tight text-amber-400 sm:text-3xl" data-id="element-174" data-mp="xyuer8te5z8z">You need one organized system.</p>
        </div>
      </div>
    </section>;
}